import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import {
  selectState,
  setUpdateInputItemPopover,
} from "../input.slice";
import DeleteInputModal from "./DeleteInputModal";
import Loader from "components/Loader/Loader";
import { FormatNumber } from "utils/numberUtils";
import classes from "../styles/TopSection.module.scss";
import ConsumablesInput from "./ConsumablesInput";
import Popover from "components/Popover/Popover";
import UpdateConsumablesInputItemPopover from "./UpdateConsumablesInputItemPopover";
import { usePartnerOptions } from "Dashboard/scenes/Partners/hooks/PartnerOptions";
import InfoTooltip from "components/Popup/InfoTooltip";

interface IProps {
  lastTableElementRef?: any;
  handleScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  doSortBy: (newSortColumn: string) => void;
}

const TopSection = ({ lastTableElementRef, handleScroll, doSortBy }: IProps) => {
  const dispatch = useAppDispatch();
  const {
    inputs,
    totalInitialValueAllInputs,
    totalRemainingValueAllInputs,
    totalQuantityAmountRemaining,
    totalQuantityAmountTotal,
    inputsLoading,
    updateInputItemPopover
  } = useSelector(selectState);
  const partnerOptions = usePartnerOptions();

  return (
    <section>
      <div className="g-grid g-header">
        <div className="row">
          <div></div>
          <div className="col lowercase center separator-line">šifra artikla</div>
          <div className="col lowercase center separator-line">br. otpr-rač</div>
          <div className="col capitalize separator-line clickable"
            onClick={() => doSortBy("NAME")}>
            Ime
          </div>
          <div className="col lowercase center separator-line">dobavljač</div>
          <div className="col lowercase center separator-line clickable"
            onClick={() => doSortBy("CATEGORY")}>
            kategorija
          </div>
          <div className="col lowercase center separator-line">kol ostalo</div>
          <div className="col lowercase center separator-line">mera</div>
          <div className="col lowercase center separator-line">ukupno ostalo</div>
          <div className="col lowercase center separator-line">količina</div>
          <div className="col lowercase center separator-line">cena po kom.</div>
          <div className="col lowercase center separator-line">ukupno uneto</div>
          <div className="col lowercase center separator-line clickable"
            onClick={() => doSortBy("DATE")}>
            datum ulaza
          </div>
        </div>
      </div>

      <div className={`scroll-content g-grid g-content ${classes.table}`} onScroll={handleScroll}>
        {inputsLoading && <Loader />}
        {inputs.length > 0 &&
          inputs.map((input, index) => {
            const isLast = index === inputs.length - 1;
            return (
              <ConsumablesInput
                key={`${input.inputId}`}
                input={input}
                partnerOptions={partnerOptions}
                index={index}
                lastTableElementRef={isLast ? lastTableElementRef : undefined} />
            );
          })}
        <Popover
          isOpen={updateInputItemPopover.isOpen}
          onClose={() => {
            dispatch(setUpdateInputItemPopover({ isOpen: false, itemRowIndex: -1 }));
          }}
          direction="right"
          title="Šifra, ime, cena artikla"
          arrowStyle={{ left: "-15px", top: "50px" }}
          position={{
            top: updateInputItemPopover.top,
            left: updateInputItemPopover.left,
            offsetLeft: 50,
            offsetTop: -60,
          }}
        >
          <UpdateConsumablesInputItemPopover />
        </Popover>
      </div>

      <div className="g-grid g-footer">
        <div className="row">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div className="col strong">
            <div className="bg-item bg-item-important right danger">
              <span className="text-small">{FormatNumber(totalQuantityAmountRemaining)}</span>
            </div>
          </div>
          <div className="col strong total-price">
            <div className="bg-item bg-item-important overflowMinWidth right">
              <InfoTooltip classesProp="bg-text-overflow text-small"
                element="span" tooltip={`${FormatNumber(totalRemainingValueAllInputs)} rsd`}>
                {FormatNumber(totalRemainingValueAllInputs)} rsd
              </InfoTooltip>
            </div>
          </div>
          <div className="col strong">
            <div className="bg-item bg-item-important right">
              <span className="text-small">{FormatNumber(totalQuantityAmountTotal)}</span>
            </div>
          </div>
          <div></div>

          <div className="col strong left total-price">
            <div className="bg-item bg-item-important overflowMinWidth">
              <InfoTooltip classesProp="bg-text-overflow text-small"
                element="span" tooltip={`${FormatNumber(totalInitialValueAllInputs)} rsd`}>
                {FormatNumber(totalInitialValueAllInputs)} rsd
              </InfoTooltip>
            </div>
          </div>
        </div>
      </div>
      <DeleteInputModal />
    </section>
  );
};

export default TopSection;
